import { FEATURE_FLAG_DEFAULTS, FeatureFlag } from '@/constants/feature-flags.ts';
import { useFeatureFlag as useConfigCatFeatureFlag } from 'configcat-react';

import { useConfigCatUser } from '@/hooks/use-config-cat-user.ts';

export const useFeatureFlag = (flag: FeatureFlag): { value: boolean; loading: boolean } => {
    const user = useConfigCatUser();

    return useConfigCatFeatureFlag(flag, FEATURE_FLAG_DEFAULTS[flag], user);
};
